module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [(_vm.description) ? _c('AppHtmlRender', {
    attrs: {
      "mod": "big",
      "htmlString": _vm.description
    }
  }) : _vm._e(), (_vm.qualitiesDesc) ? _c('AppCardDescriptionBlockLayout', [_c('AppTypeIcon', {
    attrs: {
      "type": "base"
    }
  }), _c('AppHeading', {
    attrs: {
      "level": "3",
      "mod": "bold, uppercase, no-bottom"
    }
  }, [_vm._v("Качества, которыми должен обладать специалист")]), _c('AppHtmlRender', {
    attrs: {
      "mod": "big",
      "htmlString": _vm.qualitiesDesc
    }
  })], 1) : _vm._e(), (_vm.interestsDesc) ? _c('AppCardDescriptionBlockLayout', [_c('AppTypeIcon', {
    attrs: {
      "type": "doc"
    }
  }), _c('AppHeading', {
    attrs: {
      "level": "3",
      "mod": "bold, uppercase, no-bottom"
    }
  }, [_vm._v("Интересы, наличие которых рекомендовано для освоения профессии")]), _c('AppHtmlRender', {
    attrs: {
      "mod": "big",
      "htmlString": _vm.interestsDesc
    }
  })], 1) : _vm._e(), (_vm.contraindicationsDesc) ? _c('AppCardDescriptionBlockLayout', [_c('AppTypeIcon', {
    attrs: {
      "type": "warning"
    }
  }), _c('AppHeading', {
    attrs: {
      "level": "3",
      "mod": "bold, uppercase, no-bottom"
    }
  }, [_vm._v("Противопоказания")]), _c('AppHtmlRender', {
    attrs: {
      "mod": "big",
      "htmlString": _vm.contraindicationsDesc
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8584b94","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/professions/card/info/ProfessionInfo.vue
// module id = 348abd743c7c90505eeb
// module chunks = 51